import React from 'react'
import { Link, NavLink, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import LanguageSwitcher from './LanguageSwitcher'
import AccountButton from './AccountButton'
import NotificationBell from './NotificationBell'
import logoUrl from '../assets/locapiol.jpeg'

const linkClass = ({ isActive }) =>
  `block font-semibold px-3 py-2 rounded-md transition ${
    isActive
      ? "text-primary bg-blue-50 underline underline-offset-4 decoration-2"
      : "text-ink hover:text-primary"
  }`

export default function Nav() {
  const [open, setOpen] = React.useState(false)
  const [showDropdown, setShowDropdown] = React.useState(false)
  const { t } = useTranslation()
  const navigate = useNavigate()

  const goToNotifications = () => {
    navigate("/notifications")
  }

  return (
    <header className="sticky top-0 bg-white/90 backdrop-blur border-b border-blue-100 z-[2000] isolate">
      <div className="container mx-auto px-4 flex items-center gap-4 min-h-[64px]">

        {/* LOGO */}
        <Link to="/" className="flex items-center gap-2 font-extrabold text-ink">
          <img
            className="w-19 h-19 object-contain"
            src={logoUrl}
            alt="Locapiol"
            width={32}
            height={32}
            loading="eager"
            decoding="async"
          />
          <span>Locapiol</span>
        </Link>

        {/* MAIN NAV (desktop) */}
        <nav className={`ml-auto items-center gap-4 ${open ? "flex flex-col absolute top-16 left-0 w-full bg-white p-4 shadow-lg z-[2100]" : "hidden md:flex"}`}>

          <NavLink to="/annonces" className={linkClass}>{t("nav.listings")}</NavLink>
          <NavLink to="/contact" className={linkClass}>{t("nav.contact")}</NavLink>

          {/* DROPDOWN "comment ça marche" */}
          <div className="relative">
            <button
              className={`${linkClass({ isActive: false })} flex items-center gap-1`}
              onClick={() => setShowDropdown(v => !v)}
            >
              {t("nav.how")}
              <svg width="12" height="12" viewBox="0 0 24 24"
                className={`transition-transform ${showDropdown ? "rotate-180" : ""}`}>
                <path d="M7 10l5 5 5-5" fill="none" stroke="currentColor"
                  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>

            {showDropdown && (
              <div className="absolute right-0 mt-2 w-56 bg-white border border-blue-100 rounded-xl shadow-card p-2 flex flex-col space-y-1 z-[2200]">
                <NavLink to="/partenaires" className={linkClass} onClick={() => setShowDropdown(false)}>
                  {t("nav.partners")}
                </NavLink>
                <NavLink to="/app-mobile" className={linkClass} onClick={() => setShowDropdown(false)}>
                  {t("nav.download")}
                </NavLink>
              </div>
            )}
          </div>

          <NavLink to="/bailleurs" className={linkClass}>{t("nav.landlords")}</NavLink>

          {/* LANGUAGE SWITCHER */}
          <LanguageSwitcher />

          {/* NOTIFICATION BELL */}
          <NotificationBell onClick={goToNotifications} />

          {/* ACCOUNT MENU */}
          <AccountButton />
        </nav>

        {/* MOBILE BURGER BUTTON */}
        <button className="md:hidden ml-2" onClick={() => setOpen(v => !v)} aria-label="Menu">
          <span className="block w-6 h-0.5 bg-ink mb-1"></span>
          <span className="block w-6 h-0.5 bg-ink mb-1"></span>
          <span className="block w-6 h-0.5 bg-ink"></span>
        </button>
      </div>
    </header>
  )
}
